import { combineReducers } from "redux";
import routeReducer from "./routeReducer";
import vehiclesReducer from "./vehicleReducer";
import metricsReducer from "./metricsReducer";
import popupReducer from "./popupReducer";
import vehicleSelectionReducer from "./vehicleSelectionReducer";
import vehicleListReducer from "./vehicleListReducer";
import mapDateSelectionReducer from "./mapDateSelectionReducer";
import settingsReducer from "./settingsReducer";
import resetRelayReducer from "./resetRelayReducer";
import logsReducer from "./logsReducer";
import notificationsReducer from "./notificationsReducer";

const rootReducer = combineReducers({
  vehicleRoutes: routeReducer,
  vehicle: vehiclesReducer,
  metrics: metricsReducer,
  popupView: popupReducer,
  vehicleSelection: vehicleSelectionReducer,
  vehicleList: vehicleListReducer,
  mapDate: mapDateSelectionReducer,
  settings: settingsReducer,
  resetRelay: resetRelayReducer,
  logs: logsReducer,
  notifications: notificationsReducer,
});

export default rootReducer;

//export type State = ReturnType<typeof rootReducer>;
